import { useEffect, useState } from "react";
import api, { fileUrl } from "../../lib/api";
import { Download, FileText } from "lucide-react";
import AnimatedImage from "../../components/AnimatedImage";
import SeoHead from "../../components/SeoHead";

export default function Resources() {
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState("All");
    useEffect(() => { api.get("/resources").then(({ data }) => setItems(data)).catch(() => {}); }, []);

    const categories = ["All", ...Array.from(new Set(items.map((i) => i.category)))];
    const filtered = filter === "All" ? items : items.filter((i) => i.category === filter);

    return (
        <div data-testid="resources-page">
            <SeoHead pageKey="resources" />
            <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-12">
                <div className="text-xs uppercase tracking-[0.22em] text-muted-foreground mb-4">Resources & Publications</div>
                <h1 className="font-display text-5xl sm:text-6xl leading-[1.05] max-w-4xl mb-6">Knowledge that builds credibility.</h1>
                <p className="text-lg text-muted-foreground max-w-3xl">
                    Our strategic plans, research reports, assessments, case studies, policy briefs, learning documents and annual reports.
                </p>
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-20">
                <div className="flex flex-wrap gap-2 mb-10" data-testid="resource-filters">
                    {categories.map((c) => (
                        <button
                            key={c}
                            onClick={() => setFilter(c)}
                            className={`px-4 py-2 rounded-sm text-xs uppercase tracking-[0.18em] border transition-colors ${
                                filter === c ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary/60"
                            }`}
                            data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            {c}
                        </button>
                    ))}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {filtered.map((r) => (
                        <article key={r.id} className="bg-card border border-border rounded-sm overflow-hidden flex flex-col" data-testid={`resource-${r.id}`}>
                            <div className="aspect-[16/10]">
                                <AnimatedImage src={r.image_url} alt={r.title} className="w-full h-full" />
                            </div>
                            <div className="p-6 flex-1 flex flex-col">
                                <div className="flex items-center justify-between text-xs uppercase tracking-[0.18em] mb-3">
                                    <span className="text-primary">{r.category}</span>
                                    {r.year && <span className="text-muted-foreground">{r.year}</span>}
                                </div>
                                <h3 className="font-display text-xl mb-3 leading-tight">{r.title}</h3>
                                <p className="text-sm text-muted-foreground mb-5 flex-1">{r.description}</p>
                                {r.file_url ? (
                                    <a
                                        href={fileUrl(r.file_url)}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="inline-flex items-center gap-2 text-sm text-primary hover:underline"
                                    >
                                        <Download size={14} /> Download
                                    </a>
                                ) : (
                                    <span className="inline-flex items-center gap-2 text-sm text-muted-foreground">
                                        <FileText size={14} /> Available on request
                                    </span>
                                )}
                            </div>
                        </article>
                    ))}
                </div>
                {filtered.length === 0 && (
                    <div className="text-center text-muted-foreground py-20">No resources in this category yet.</div>
                )}
            </section>
        </div>
    );
}
